<template>
  <div style="padding:10px"> 
    <!-- @search="getir()" -->
    <van-search v-model="obj.where.kelime" background="#f0f0f0" placeholder="Stok ara" @search="getir('search')"/>
    <van-notice-bar v-if="message" color="#484848" background="#fff" left-icon="info-o"> {{message}} </van-notice-bar>
    <!-- <van-search v-model="search" background="#f0f0f0" placeholder="Stok ara" /> -->
    <van-pull-refresh v-model="pullrefresh" @refresh="getir">
      <van-swipe-cell v-for="(item, index) in $store.getters.getStok.liste" :key="index">
        <van-cell :border="false" :value="$helper.ilkharfBuyuk(item.isim).substring(0, 70)" icon="apps-o" style="padding-left:2px"   @click="detay(item)"/>
          <template #right>
            <van-button square color="#002375" text="Düzenle" @click="detay(item)" />
          </template>
      </van-swipe-cell>
    </van-pull-refresh>
<van-button block @click="getir('sayfalama')">{{sayfalamamesaj}}</van-button>
     <!-- <van-empty description="Arayın, okutun" class="custom-image" style="position:relative">

     <div v-once class="component-barcode-scanner">
        <div class="dce-video-container">
          <div class="dce-scanarea">
            <div class="dce-scanlight"></div>
          </div>
          <div class="div-select-container">
            <select class="dce-sel-camera" style="display:none"></select>
            <select class="dce-sel-resolution"  style="display:none"></select>
          </div>
        </div>
      </div>
     </van-empty> -->

     <detay v-if="detayac" 
     :show="detayac" 
     :depolar="$store.getters.getStok.aktif.depomiktar" 
     :durum="icon"
     @addVirtual ="addVirtual($event)"
     @closePop="closePop()"
     />
     <!-- @addBasket ="addBasket($event)" substratta liste var sepet yok-->



</div>
</template>

<script>
import detay from "@/components/detay";
import card from "@/components/card";

import "@/dbr";
import { BarcodeScanner } from 'dynamsoft-javascript-barcode'
export default {
components:{
detay,card
},
data() {
    return {
      sayfalamamesaj : 'Daha fazla ürün',
      hesap:this.$store.getters.getHesap,
      secilen:{}, // detay popup açılınca seçilen obje
      pullrefresh : false,
      detayac:false, // stok detay
      depolist: {
        show:false,
        stokisim :'',
        miktar : []
      },
      bitti:false,
      icon: {
        1: {
          icon: "passed",
          text: "Stok var",
          color:'green'
        },
        2: {
          icon: "fire-0",
          text: "Kritik stok",
          color:'yellow'

        },
        3: {
          icon: "clock-o",
          text: "Stok yolda",
          color:'blue'

        },
        4: {
          icon: "close",
          text: "Stok yok",
          color:'red'
        },
      },
      obj:{
        ckod: this.$store.getters.getCari.aktif.kod,
        cari_iskonto_kod:this.$store.getters.getCari.aktif.iskontokod,
        where: {
          marka:{},
              anagrup:{
                altgrup : []
              },
              altgrup:{},
          guid: 0,
          kelime: '',
          web: 0,
          mevcut:0,
          kampanya: 0,
          yeni: 0,
        },
        gruplama: 0,
        order: {
          key: 'isim',
          value: 'asc'
        },
        sayfa:0,
        sayfalama: 1000 // çalışmıyor
      },

      hata: [],
      stokhareket: [],
      sepet: [],
      varyant: [],
      mesaj: "",
      sabit : {
          marka:[],
          category:[],
      },
      sabitler:['marka','category'],
      message : ''
    };
  },
  // },
  async beforeDestroy() {
    if (this.pScanner) {
      (await this.pScanner).destroyContext();
      //console.log('BarcodeSanner Component Unmount');
    }
  },
  computed:{
    // filteredList() {
    //   return this.$store.getters.getStok.liste.filter(post => {
    //     return post.isim.toLowerCase().includes(this.search.toLowerCase())
    //   })
    // }    
  },
  created() { 
    this.$store.commit("setLoading",[false,'...'])
  },

  methods: {

    async barkodac(){
    try {
      const scanner = await (this.pScanner = BarcodeScanner.createInstance());
      await scanner.setUIElement(this.$el);
      scanner.onFrameRead = (results) => {
        for (let result of results) {
          console.log(result.barcodeText);
        }
      };
      scanner.onUniqueRead = (txt, result) => {
        this.getir(txt)
      //this.barkod = 0
        //alert(txt, result);
      }
      await scanner.open();
    } catch (ex) {
      if (ex.message.indexOf("network connection error")) {
        let customMsg = "Admin ile iletişime geç";
        //console.log(customMsg);
        alert(customMsg);
      }
      throw ex;
    }      
    },
    getir(durum){
      if (durum == 'search') this.obj.sayfa = 0;
      this.obj.sayfa++
      this.obj.where.guid = 0 // detay yüzünden
      this.$store.commit("setLoading",[true,'Bekleyiniz'])
      this.message = ''
        this.$request
          .post(this.hesap.program + "/stoklist/",{giden: this.obj,nereden: true},this.hesap).then((stoklist) => {
            console.log(stoklist)
              if (stoklist.status) {
                // this.message = stoklist.data.length+ ' adet ürün bulundu';
                if (stoklist.data.length == 0) {this.sayfalamamesaj = "Kayıt sonu"}
                else {this.sayfalamamesaj = "Daha fazla ürün"}

                this.message = this.obj.where.kelime+ ' kelimesi arandı';
                this.$store.dispatch("stoklist",{data:stoklist.data,sayfa:this.obj.sayfa})
                this.$store.commit("setLoading",[false,'...'])
              }
              else {
                this.$store.commit("setLoading",[false,'...'])
                this.message = stoklist.message;
              }
          })
    },
    addBasket(obje) {
      let obj = {
        obje :obje,
        helper : this.$helper,
        req : this.$request,
        notify:this.$notify,
        dialog:this.$dialog,
      }
      this.$store.dispatch("durumkontrol",obj)
    },

    detay(obj) {
      if (this.obj.ckod != 0) {      
      this.obj.where.guid = obj.guid;
      this.$store.commit("setLoading",[true,'Bekleyiniz'])
      this.detayac = true                
      this.$store.dispatch('setStok' , {data:obj,nereye:'aktif'})
      this.$store.commit("setLoading",[false,'...'])
      //this.message = ''
       // this.$request
          //.post(this.hesap.program + "/stoklist/",{giden: this.obj},this.hesap).then((stoklist) => {
           // console.log(stoklist)
             // if (stoklist.status) {
               // this.detayac = true
              //  this.$store.commit('setStok' , {data:stoklist.data[0],nereye:'aktif'})
              //  this.$store.commit("setLoading",[false,'...'])
            //  }
            //  else {
               // this.$store.commit("setLoading",[false,'...'])
               // this.message = "Tekrar Deneyiniz" 
             // }
          //})      

      // this.$request.post(this.hesap.program+"/depo/miktar",{ stok : obj.guid,stokkod :obj.kod }).then((res) => {
      //   this.$store.commit('setDepomiktar',res.data)
      // })
      }
      else {
        this.$notify({ type: 'danger', message: 'Müşteri Seç' });
      }
    },
    addVirtual(item) {
      // if (nerden == 'undefined') {this.detayac = false}
      this.$store.commit("setLoading",[true,'Bekleyiniz'])

        var data = {};
        let index = this.$store.getters.getVirtual.proforma[this.obj.ckod].findIndex((obj) => obj.guid == item.data.guid);
            if (index === -1) {
                data = {
                  ...item.data,
                  adet2: 1, // adet endpoint deki toplam stok sayısı
                  id: 0, // kayıtsız olduğu sadece tarayıcıda kayıtlı olduğu anlamına gelir
                  satiraddTarih: this.$helper.getNow().full,
                  satirupdateTarih: this.$helper.getNow().full,
                  depo: item.depo_kod,
                  depoalias: "Atanmamış",
                  parite: 1,
                  iskonto: 0,
                  doviz_cinsi: item.doviz_cinsi,
                  fiyat : item.fiyat
                };

              this.$store.commit("addVirtual", data);
            } else {
              let dataUpdate = {
                islem: "arttir",
                index: index,
                tarih: this.$helper.getNow().full,
                virtual: this.virtual,
              };
              this.$store.commit("updateVirtual", dataUpdate);
            }
            this.$store.commit("setLoading",[false,'...'])
            this.$notify({ type: 'success', message: 'İşlem Başarılı' });
            setTimeout(() => {
              this.closePop()
            }, 2000);
  
    },    

    closePop(){
      this.detayac = false
    }  

    },
};
</script>
<style scoped>
.van-cell__left-icon{
  font-size:18px !important
}
.van-cell__right-icon{
  font-size:12px !important
}
.van-popup__close-icon--top-right{
  top:1px !important
}
</style>


// WEBPACK FOOTER //
// src/views/stok.vue